/** Curated ET-706 destination adapters. Source names describe records and business facts. */
export interface TaxFieldMapping { pdfField: string; entity: string; field: string; label: string; location: string; selector: string | null; }
export const ET706_FIELD_MAPPINGS: TaxFieldMapping[] = [
  {
    "pdfField": "Decedent_address",
    "entity": "decedent",
    "field": "addresses[0].addressLine1",
    "label": "Street address",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "Decedent_last",
    "entity": "decedent",
    "field": "lastName",
    "label": "Last name",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "Decedent_first",
    "entity": "decedent",
    "field": "firstName",
    "label": "First name",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "Decedent_MI",
    "entity": "decedent",
    "field": "middleInitial",
    "label": "Middle initial",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "Decedent_city",
    "entity": "decedent",
    "field": "addresses[0].city",
    "label": "City",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "Decedent_state",
    "entity": "decedent",
    "field": "addresses[0].state",
    "label": "State",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "Decedent_ZIP",
    "entity": "decedent",
    "field": "addresses[0].zipCode",
    "label": "ZIP code",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "Amended_return",
    "entity": "estateTaxFiling",
    "field": "amendedReturn",
    "label": "Amended return",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "Federal_audit",
    "entity": "estateTaxFiling",
    "field": "federalAuditChanges",
    "label": "Return reflects federal audit changes",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "DateDeath",
    "entity": "decedent",
    "field": "dateOfDeath",
    "label": "Date of death",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "DeathCert",
    "entity": "estateTaxFiling",
    "field": "deathCertificateAttached",
    "label": "Death certificate attached",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "SSN",
    "entity": "decedent",
    "field": "ssn",
    "label": "Social Security number",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "County",
    "entity": "decedent",
    "field": "addresses[0].county",
    "label": "County of residence",
    "location": "Participants → decedent record (name, SSN, date of death, address incl. county); Estate details marks the decedent",
    "selector": null
  },
  {
    "pdfField": "EIN",
    "entity": "estate",
    "field": "ein",
    "label": "Estate EIN",
    "location": "Estate details",
    "selector": null
  },
  {
    "pdfField": "Name_EINTrusts",
    "entity": "estateTaxFiling",
    "field": "trustsCreatedByWill",
    "label": "Names and EINs of trusts created or funded by the will",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "DecedantNonResident",
    "entity": "estateTax",
    "field": "nonresident",
    "label": "Decedent was a nonresident of New York",
    "location": "Computed: decedent address state is not NY (Participants → decedent address)",
    "selector": null
  },
  {
    "pdfField": "PoAX",
    "entity": "estateTaxFiling",
    "field": "powerOfAttorneyAttached",
    "label": "Power of attorney attached",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "PoA_Form",
    "entity": "estateTaxFiling",
    "field": "powerOfAttorneyForm",
    "label": "Power of attorney form number",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "PoA_Date",
    "entity": "estateTaxFiling",
    "field": "powerOfAttorneyDate",
    "label": "Power of attorney date",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "Executor_Letters",
    "entity": "estateTaxFiling",
    "field": "executorLetters",
    "label": "Letters submitted with this return (L regular, LL limited, N none)",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "SurrogateCourt",
    "entity": "estate",
    "field": "courtCounty",
    "label": "Surrogate's Court county",
    "location": "Estate details",
    "selector": null
  },
  {
    "pdfField": "ICO_firm",
    "entity": "taxRepresentative",
    "field": "professionalFirmName",
    "label": "Firm name (in care of)",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_last_name",
    "entity": "taxRepresentative",
    "field": "lastName",
    "label": "Last name",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_first_name",
    "entity": "taxRepresentative",
    "field": "firstName",
    "label": "First name",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_MI",
    "entity": "taxRepresentative",
    "field": "middleInitial",
    "label": "Middle initial",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Exec_last_name",
    "entity": "executor",
    "field": "lastName",
    "label": "Last name",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_first_name",
    "entity": "executor",
    "field": "firstName",
    "label": "First name",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_MI",
    "entity": "executor",
    "field": "middleInitial",
    "label": "Middle initial",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "ExcecutorX",
    "entity": "estateTax",
    "field": "multipleExecutors",
    "label": "More than one executor",
    "location": "Computed: more than one executor selected in Estate details",
    "selector": null
  },
  {
    "pdfField": "Rep_address",
    "entity": "taxRepresentative",
    "field": "addresses[0].addressLine1",
    "label": "Street address",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_city",
    "entity": "taxRepresentative",
    "field": "addresses[0].city",
    "label": "City",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_State",
    "entity": "taxRepresentative",
    "field": "addresses[0].state",
    "label": "State",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_ZIP",
    "entity": "taxRepresentative",
    "field": "addresses[0].zipCode",
    "label": "ZIP code",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_SSN",
    "entity": "taxRepresentative",
    "field": "taxIdentifier",
    "label": "PTIN or SSN",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_phone",
    "entity": "taxRepresentative",
    "field": "phone",
    "label": "Telephone",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Rep_email",
    "entity": "taxRepresentative",
    "field": "email",
    "label": "Email",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Exec_address",
    "entity": "executor",
    "field": "addresses[0].addressLine1",
    "label": "Street address",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_city",
    "entity": "executor",
    "field": "addresses[0].city",
    "label": "City",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_State",
    "entity": "executor",
    "field": "addresses[0].state",
    "label": "State",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_ZIP",
    "entity": "executor",
    "field": "addresses[0].zipCode",
    "label": "ZIP code",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_SSN",
    "entity": "executor",
    "field": "ssn",
    "label": "Social Security number",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_phone",
    "entity": "executor",
    "field": "phone",
    "label": "Telephone",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "Exec_email",
    "entity": "executor",
    "field": "email",
    "label": "Email",
    "location": "Participants → executor record (name, SSN, phone, email, address); Estate details → Executors",
    "selector": null
  },
  {
    "pdfField": "ScheduleF",
    "entity": "estateTaxFiling",
    "field": "litigationInvolvingDecedent",
    "label": "Decedent possessed a cause of action or was a plaintiff in litigation",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "Installment",
    "entity": "estateTaxFiling",
    "field": "installmentElection",
    "label": "Elect installment payment of estate tax",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "Counties",
    "entity": "estateTaxFiling",
    "field": "lienReleaseCountyCount",
    "label": "Number of counties requiring releases of lien",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "FedEstate",
    "entity": "estateTaxFiling",
    "field": "federalReturnRequired",
    "label": "Federal estate-tax return required",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "Terminable",
    "entity": "estateTaxFiling",
    "field": "terminableInterestElection",
    "label": "Elect qualified terminable interest property treatment",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "SSNSurviving",
    "entity": "survivingSpouse",
    "field": "ssn",
    "label": "Social Security number",
    "location": "Family Tree spouse relationship + Participants → spouse SSN (spouse known to have died before the decedent is excluded)",
    "selector": null
  },
  {
    "pdfField": "Line1",
    "entity": "estateTax",
    "field": "taxableEstateDollars",
    "label": "Taxable estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine1",
    "entity": "estateTax",
    "field": "taxableEstateCents",
    "label": "Taxable estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line2",
    "entity": "estateTax",
    "field": "taxDollars",
    "label": "Tax dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine2",
    "entity": "estateTax",
    "field": "taxCents",
    "label": "Tax cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line3",
    "entity": "estateTax",
    "field": "applicableCreditDollars",
    "label": "Applicable credit dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine3",
    "entity": "estateTax",
    "field": "applicableCreditCents",
    "label": "Applicable credit cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line4",
    "entity": "estateTax",
    "field": "taxAfterCreditDollars",
    "label": "Tax after credit dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine4",
    "entity": "estateTax",
    "field": "taxAfterCreditCents",
    "label": "Tax after credit cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line5",
    "entity": "estateTax",
    "field": "priorTaxPaymentsDollars",
    "label": "Prior tax payments dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine5",
    "entity": "estateTax",
    "field": "priorTaxPaymentsCents",
    "label": "Prior tax payments cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line6",
    "entity": "estateTax",
    "field": "amountDueDollars",
    "label": "Amount due dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine6",
    "entity": "estateTax",
    "field": "amountDueCents",
    "label": "Amount due cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line7",
    "entity": "estateTax",
    "field": "refundDollars",
    "label": "Refund dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine7",
    "entity": "estateTax",
    "field": "refundCents",
    "label": "Refund cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.0",
    "entity": "estateTax",
    "field": "residentFederalGrossEstateDollars",
    "label": "Resident federal gross estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.1",
    "entity": "estateTax",
    "field": "residentOutsidePropertyDollars",
    "label": "Resident outside property dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.2",
    "entity": "estateTax",
    "field": "residentFederalEstateInNewYorkDollars",
    "label": "Resident federal estate in new york dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.3",
    "entity": "estateTax",
    "field": "residentPre1930PropertyDollars",
    "label": "Resident pre1930 property dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.4",
    "entity": "estateTax",
    "field": "residentTaxableGiftsDollars",
    "label": "Resident taxable gifts dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.5",
    "entity": "estateTax",
    "field": "residentQtipInclusionDollars",
    "label": "Resident qtip inclusion dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.6",
    "entity": "estateTax",
    "field": "residentGrossEstateDollars",
    "label": "Resident gross estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.7",
    "entity": "estateTax",
    "field": "residentFederalDeductionsDollars",
    "label": "Resident federal deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.8",
    "entity": "estateTax",
    "field": "residentDisallowedDeductionsDollars",
    "label": "Resident disallowed deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.9",
    "entity": "estateTax",
    "field": "residentAllowedDeductionsDollars",
    "label": "Resident allowed deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.10",
    "entity": "estateTax",
    "field": "residentTaxableEstateDollars",
    "label": "Resident taxable estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.11",
    "entity": "estateTax",
    "field": "nonresidentFederalGrossEstateDollars",
    "label": "Nonresident federal gross estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.12",
    "entity": "estateTax",
    "field": "nonresidentOutsidePropertyDollars",
    "label": "Nonresident outside property dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.13",
    "entity": "estateTax",
    "field": "nonresidentIntangiblePropertyDollars",
    "label": "Nonresident intangible property dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.14",
    "entity": "estateTax",
    "field": "nonresidentNontaxableEstateDollars",
    "label": "Nonresident nontaxable estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.15",
    "entity": "estateTax",
    "field": "nonresidentFederalEstateInNewYorkDollars",
    "label": "Nonresident federal estate in new york dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.16",
    "entity": "estateTax",
    "field": "nonresidentPre1930PropertyDollars",
    "label": "Nonresident pre1930 property dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.17",
    "entity": "estateTax",
    "field": "nonresidentTaxableGiftsDollars",
    "label": "Nonresident taxable gifts dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.18",
    "entity": "estateTax",
    "field": "nonresidentQtipInclusionDollars",
    "label": "Nonresident qtip inclusion dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.19",
    "entity": "estateTax",
    "field": "nonresidentGrossEstateDollars",
    "label": "Nonresident gross estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.20",
    "entity": "estateTax",
    "field": "nonresidentFederalDeductionsDollars",
    "label": "Nonresident federal deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.21",
    "entity": "estateTax",
    "field": "nonresidentDisallowedDeductionsDollars",
    "label": "Nonresident disallowed deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.22",
    "entity": "estateTax",
    "field": "nonresidentAllowedDeductionsDollars",
    "label": "Nonresident allowed deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.23",
    "entity": "estateTax",
    "field": "nonresidentTentativeTaxableEstateDollars",
    "label": "Nonresident tentative taxable estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.24",
    "entity": "estateTax",
    "field": "nonresidentArtOnLoanDollars",
    "label": "Nonresident art on loan dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line8.25",
    "entity": "estateTax",
    "field": "nonresidentTaxableEstateDollars",
    "label": "Nonresident taxable estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.0",
    "entity": "estateTax",
    "field": "residentFederalGrossEstateCents",
    "label": "Resident federal gross estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.1",
    "entity": "estateTax",
    "field": "residentOutsidePropertyCents",
    "label": "Resident outside property cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.2",
    "entity": "estateTax",
    "field": "residentFederalEstateInNewYorkCents",
    "label": "Resident federal estate in new york cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.3",
    "entity": "estateTax",
    "field": "residentPre1930PropertyCents",
    "label": "Resident pre1930 property cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.4",
    "entity": "estateTax",
    "field": "residentTaxableGiftsCents",
    "label": "Resident taxable gifts cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.5",
    "entity": "estateTax",
    "field": "residentQtipInclusionCents",
    "label": "Resident qtip inclusion cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.6",
    "entity": "estateTax",
    "field": "residentGrossEstateCents",
    "label": "Resident gross estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.11",
    "entity": "estateTax",
    "field": "nonresidentFederalGrossEstateCents",
    "label": "Nonresident federal gross estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.14",
    "entity": "estateTax",
    "field": "nonresidentNontaxableEstateCents",
    "label": "Nonresident nontaxable estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.15",
    "entity": "estateTax",
    "field": "nonresidentFederalEstateInNewYorkCents",
    "label": "Nonresident federal estate in new york cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.16",
    "entity": "estateTax",
    "field": "nonresidentPre1930PropertyCents",
    "label": "Nonresident pre1930 property cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.17",
    "entity": "estateTax",
    "field": "nonresidentTaxableGiftsCents",
    "label": "Nonresident taxable gifts cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.18",
    "entity": "estateTax",
    "field": "nonresidentQtipInclusionCents",
    "label": "Nonresident qtip inclusion cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.19",
    "entity": "estateTax",
    "field": "nonresidentGrossEstateCents",
    "label": "Nonresident gross estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.22",
    "entity": "estateTax",
    "field": "nonresidentAllowedDeductionsCents",
    "label": "Nonresident allowed deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.23",
    "entity": "estateTax",
    "field": "nonresidentTentativeTaxableEstateCents",
    "label": "Nonresident tentative taxable estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.24",
    "entity": "estateTax",
    "field": "nonresidentArtOnLoanCents",
    "label": "Nonresident art on loan cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.25",
    "entity": "estateTax",
    "field": "nonresidentTaxableEstateCents",
    "label": "Nonresident taxable estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.9",
    "entity": "estateTax",
    "field": "residentAllowedDeductionsCents",
    "label": "Resident allowed deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.10",
    "entity": "estateTax",
    "field": "residentTaxableEstateCents",
    "label": "Resident taxable estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.12",
    "entity": "estateTax",
    "field": "nonresidentOutsidePropertyCents",
    "label": "Nonresident outside property cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.13",
    "entity": "estateTax",
    "field": "nonresidentIntangiblePropertyCents",
    "label": "Nonresident intangible property cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.7",
    "entity": "estateTax",
    "field": "residentFederalDeductionsCents",
    "label": "Resident federal deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.8",
    "entity": "estateTax",
    "field": "residentDisallowedDeductionsCents",
    "label": "Resident disallowed deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.20",
    "entity": "estateTax",
    "field": "nonresidentFederalDeductionsCents",
    "label": "Nonresident federal deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine8.21",
    "entity": "estateTax",
    "field": "nonresidentDisallowedDeductionsCents",
    "label": "Nonresident disallowed deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "B_Item_number.0",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[0]"
  },
  {
    "pdfField": "B_Item_number.1",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[1]"
  },
  {
    "pdfField": "B_Item_number.2",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[2]"
  },
  {
    "pdfField": "B_Item_number.3",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[3]"
  },
  {
    "pdfField": "B_Item_number.4",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[4]"
  },
  {
    "pdfField": "B_Item_number.5",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[5]"
  },
  {
    "pdfField": "B_Item_number.6",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[6]"
  },
  {
    "pdfField": "B_Item_number.7",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[7]"
  },
  {
    "pdfField": "B_Item_number.8",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[8]"
  },
  {
    "pdfField": "B_Item_number.9",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[9]"
  },
  {
    "pdfField": "B_Item_number.10",
    "entity": "taxOutsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[10]"
  },
  {
    "pdfField": "B_Description.0",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[0]"
  },
  {
    "pdfField": "B_Description.1",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[1]"
  },
  {
    "pdfField": "B_Description.2",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[2]"
  },
  {
    "pdfField": "B_Description.3",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[3]"
  },
  {
    "pdfField": "B_Description.4",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[4]"
  },
  {
    "pdfField": "B_Description.5",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[5]"
  },
  {
    "pdfField": "B_Description.6",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[6]"
  },
  {
    "pdfField": "B_Description.7",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[7]"
  },
  {
    "pdfField": "B_Description.8",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[8]"
  },
  {
    "pdfField": "B_Description.9",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[9]"
  },
  {
    "pdfField": "B_Description.10",
    "entity": "taxOutsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[10]"
  },
  {
    "pdfField": "B_Value.0",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[0]"
  },
  {
    "pdfField": "B_Value.1",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[1]"
  },
  {
    "pdfField": "B_Value.2",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[2]"
  },
  {
    "pdfField": "B_Value.3",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[3]"
  },
  {
    "pdfField": "B_Value.4",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[4]"
  },
  {
    "pdfField": "B_Value.5",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[5]"
  },
  {
    "pdfField": "B_Value.6",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[6]"
  },
  {
    "pdfField": "B_Value.7",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[7]"
  },
  {
    "pdfField": "B_Value.8",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[8]"
  },
  {
    "pdfField": "B_Value.9",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[9]"
  },
  {
    "pdfField": "B_Value.10",
    "entity": "taxOutsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (in federal gross estate, real or tangible personal, located outside NY)",
    "selector": "[10]"
  },
  {
    "pdfField": "B_Value.11",
    "entity": "estateTax",
    "field": "outsidePropertyContinuationTotal",
    "label": "Outside property continuation total",
    "location": "Sum of estate-tax property records",
    "selector": null
  },
  {
    "pdfField": "B_Value.12",
    "entity": "estateTax",
    "field": "outsidePropertyTotal",
    "label": "Outside property total",
    "location": "Sum of estate-tax property records",
    "selector": null
  },
  {
    "pdfField": "C_Item_number.0",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[0]"
  },
  {
    "pdfField": "C_Item_number.1",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[1]"
  },
  {
    "pdfField": "C_Item_number.2",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[2]"
  },
  {
    "pdfField": "C_Item_number.3",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[3]"
  },
  {
    "pdfField": "C_Item_number.4",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[4]"
  },
  {
    "pdfField": "C_Item_number.5",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[5]"
  },
  {
    "pdfField": "C_Item_number.6",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[6]"
  },
  {
    "pdfField": "C_Item_number.7",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[7]"
  },
  {
    "pdfField": "C_Item_number.8",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[8]"
  },
  {
    "pdfField": "C_Item_number.9",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[9]"
  },
  {
    "pdfField": "C_Item_number.10",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[10]"
  },
  {
    "pdfField": "C_Item_number.11",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[11]"
  },
  {
    "pdfField": "C_Item_number.12",
    "entity": "taxInsideProperty",
    "field": "federalItemReference",
    "label": "Federal schedule and item number",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[12]"
  },
  {
    "pdfField": "C_Description.0",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[0]"
  },
  {
    "pdfField": "C_Description.1",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[1]"
  },
  {
    "pdfField": "C_Description.2",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[2]"
  },
  {
    "pdfField": "C_Description.3",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[3]"
  },
  {
    "pdfField": "C_Description.4",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[4]"
  },
  {
    "pdfField": "C_Description.5",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[5]"
  },
  {
    "pdfField": "C_Description.6",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[6]"
  },
  {
    "pdfField": "C_Description.7",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[7]"
  },
  {
    "pdfField": "C_Description.8",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[8]"
  },
  {
    "pdfField": "C_Description.9",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[9]"
  },
  {
    "pdfField": "C_Description.10",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[10]"
  },
  {
    "pdfField": "C_Description.11",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[11]"
  },
  {
    "pdfField": "C_Description.12",
    "entity": "taxInsideProperty",
    "field": "taxDescription",
    "label": "Description and location",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[12]"
  },
  {
    "pdfField": "C_Value.0",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[0]"
  },
  {
    "pdfField": "C_Value.1",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[1]"
  },
  {
    "pdfField": "C_Value.2",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[2]"
  },
  {
    "pdfField": "C_Value.3",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[3]"
  },
  {
    "pdfField": "C_Value.4",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[4]"
  },
  {
    "pdfField": "C_Value.5",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[5]"
  },
  {
    "pdfField": "C_Value.6",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[6]"
  },
  {
    "pdfField": "C_Value.7",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[7]"
  },
  {
    "pdfField": "C_Value.8",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[8]"
  },
  {
    "pdfField": "C_Value.9",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[9]"
  },
  {
    "pdfField": "C_Value.10",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[10]"
  },
  {
    "pdfField": "C_Value.11",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[11]"
  },
  {
    "pdfField": "C_Value.12",
    "entity": "taxInsideProperty",
    "field": "taxValue",
    "label": "Date-of-death value",
    "location": "Assets and Liabilities → asset → estate tax property details (nonresident only; real or tangible personal located in NY)",
    "selector": "[12]"
  },
  {
    "pdfField": "C_Value.13",
    "entity": "estateTax",
    "field": "insidePropertyContinuationTotal",
    "label": "Inside property continuation total",
    "location": "Sum of estate-tax property records",
    "selector": null
  },
  {
    "pdfField": "C_Value.14",
    "entity": "estateTax",
    "field": "insidePropertyTotal",
    "label": "Inside property total",
    "location": "Sum of estate-tax property records",
    "selector": null
  },
  {
    "pdfField": "D_Date_made.0",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[0]"
  },
  {
    "pdfField": "D_Date_made.1",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[1]"
  },
  {
    "pdfField": "D_Date_made.2",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[2]"
  },
  {
    "pdfField": "D_Date_made.3",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[3]"
  },
  {
    "pdfField": "D_Date_made.4",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[4]"
  },
  {
    "pdfField": "D_Date_made.5",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[5]"
  },
  {
    "pdfField": "D_Date_made.6",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[6]"
  },
  {
    "pdfField": "D_Date_made.7",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[7]"
  },
  {
    "pdfField": "D_Date_made.8",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[8]"
  },
  {
    "pdfField": "D_Date_made.9",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[9]"
  },
  {
    "pdfField": "D_Date_made.10",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[10]"
  },
  {
    "pdfField": "D_Date_made.11",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[11]"
  },
  {
    "pdfField": "D_Date_made.12",
    "entity": "taxGift",
    "field": "date",
    "label": "Gift date",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[12]"
  },
  {
    "pdfField": "D_Description.0",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[0]"
  },
  {
    "pdfField": "D_Description.1",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[1]"
  },
  {
    "pdfField": "D_Description.2",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[2]"
  },
  {
    "pdfField": "D_Description.3",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[3]"
  },
  {
    "pdfField": "D_Description.4",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[4]"
  },
  {
    "pdfField": "D_Description.5",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[5]"
  },
  {
    "pdfField": "D_Description.6",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[6]"
  },
  {
    "pdfField": "D_Description.7",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[7]"
  },
  {
    "pdfField": "D_Description.8",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[8]"
  },
  {
    "pdfField": "D_Description.9",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[9]"
  },
  {
    "pdfField": "D_Description.10",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[10]"
  },
  {
    "pdfField": "D_Description.11",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[11]"
  },
  {
    "pdfField": "D_Description.12",
    "entity": "taxGift",
    "field": "description",
    "label": "Property and location",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[12]"
  },
  {
    "pdfField": "D_Taxable_amount.0",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[0]"
  },
  {
    "pdfField": "D_Taxable_amount.1",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[1]"
  },
  {
    "pdfField": "D_Taxable_amount.2",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[2]"
  },
  {
    "pdfField": "D_Taxable_amount.3",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[3]"
  },
  {
    "pdfField": "D_Taxable_amount.4",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[4]"
  },
  {
    "pdfField": "D_Taxable_amount.5",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[5]"
  },
  {
    "pdfField": "D_Taxable_amount.6",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[6]"
  },
  {
    "pdfField": "D_Taxable_amount.7",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[7]"
  },
  {
    "pdfField": "D_Taxable_amount.8",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[8]"
  },
  {
    "pdfField": "D_Taxable_amount.9",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[9]"
  },
  {
    "pdfField": "D_Taxable_amount.10",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[10]"
  },
  {
    "pdfField": "D_Taxable_amount.11",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[11]"
  },
  {
    "pdfField": "D_Taxable_amount.12",
    "entity": "taxGift",
    "field": "taxableAmount",
    "label": "Taxable amount",
    "location": "Family Jewels → Estate tax filing → Taxable gifts",
    "selector": "[12]"
  },
  {
    "pdfField": "D_Taxable_amount.13",
    "entity": "estateTax",
    "field": "giftContinuationTotal",
    "label": "Gift continuation total",
    "location": "Sum of taxable gifts and additional-sheet amount",
    "selector": null
  },
  {
    "pdfField": "D_Taxable_amount.14",
    "entity": "estateTax",
    "field": "giftTotal",
    "label": "Gift total",
    "location": "Sum of taxable gifts and additional-sheet amount",
    "selector": null
  },
  {
    "pdfField": "E1_chart.0.0",
    "entity": "estateTax",
    "field": "residentFuneralAndAdministrationFederalTotal",
    "label": "Resident funeral and administration federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.0.1",
    "entity": "estateTax",
    "field": "residentFuneralAndAdministrationNewYork",
    "label": "Resident funeral and administration new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.0.2",
    "entity": "estateTax",
    "field": "residentFuneralAndAdministrationOutsideNewYork",
    "label": "Resident funeral and administration outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.0.3",
    "entity": "estateTax",
    "field": "residentFuneralAndAdministrationUnallocated",
    "label": "Resident funeral and administration unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.1.0",
    "entity": "estateTax",
    "field": "residentDebtsFederalTotal",
    "label": "Resident debts federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.1.1",
    "entity": "estateTax",
    "field": "residentDebtsNewYork",
    "label": "Resident debts new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.1.2",
    "entity": "estateTax",
    "field": "residentDebtsOutsideNewYork",
    "label": "Resident debts outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.1.3",
    "entity": "estateTax",
    "field": "residentDebtsUnallocated",
    "label": "Resident debts unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.2.0",
    "entity": "estateTax",
    "field": "residentMortgagesAndLiensFederalTotal",
    "label": "Resident mortgages and liens federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.2.1",
    "entity": "estateTax",
    "field": "residentMortgagesAndLiensNewYork",
    "label": "Resident mortgages and liens new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.2.2",
    "entity": "estateTax",
    "field": "residentMortgagesAndLiensOutsideNewYork",
    "label": "Resident mortgages and liens outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.2.3",
    "entity": "estateTax",
    "field": "residentMortgagesAndLiensUnallocated",
    "label": "Resident mortgages and liens unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.3.0",
    "entity": "estateTax",
    "field": "residentClaimsTotalFederalTotal",
    "label": "Resident claims total federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.3.1",
    "entity": "estateTax",
    "field": "residentClaimsTotalNewYork",
    "label": "Resident claims total new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.3.2",
    "entity": "estateTax",
    "field": "residentClaimsTotalOutsideNewYork",
    "label": "Resident claims total outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.3.3",
    "entity": "estateTax",
    "field": "residentClaimsTotalUnallocated",
    "label": "Resident claims total unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.4.0",
    "entity": "estateTax",
    "field": "residentAllowableClaimsFederalTotal",
    "label": "Resident allowable claims federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.4.1",
    "entity": "estateTax",
    "field": "residentAllowableClaimsNewYork",
    "label": "Resident allowable claims new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.4.2",
    "entity": "estateTax",
    "field": "residentAllowableClaimsOutsideNewYork",
    "label": "Resident allowable claims outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.4.3",
    "entity": "estateTax",
    "field": "residentAllowableClaimsUnallocated",
    "label": "Resident allowable claims unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.5.0",
    "entity": "estateTax",
    "field": "residentAdministrationLossFederalTotal",
    "label": "Resident administration loss federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.5.1",
    "entity": "estateTax",
    "field": "residentAdministrationLossNewYork",
    "label": "Resident administration loss new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.5.2",
    "entity": "estateTax",
    "field": "residentAdministrationLossOutsideNewYork",
    "label": "Resident administration loss outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.5.3",
    "entity": "estateTax",
    "field": "residentAdministrationLossUnallocated",
    "label": "Resident administration loss unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.6.0",
    "entity": "estateTax",
    "field": "residentNonClaimExpenseFederalTotal",
    "label": "Resident non claim expense federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.6.1",
    "entity": "estateTax",
    "field": "residentNonClaimExpenseNewYork",
    "label": "Resident non claim expense new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.6.2",
    "entity": "estateTax",
    "field": "residentNonClaimExpenseOutsideNewYork",
    "label": "Resident non claim expense outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.6.3",
    "entity": "estateTax",
    "field": "residentNonClaimExpenseUnallocated",
    "label": "Resident non claim expense unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.7.0",
    "entity": "estateTax",
    "field": "residentMaritalBequestsFederalTotal",
    "label": "Resident marital bequests federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.7.1",
    "entity": "estateTax",
    "field": "residentMaritalBequestsNewYork",
    "label": "Resident marital bequests new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.7.2",
    "entity": "estateTax",
    "field": "residentMaritalBequestsOutsideNewYork",
    "label": "Resident marital bequests outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.7.3",
    "entity": "estateTax",
    "field": "residentMaritalBequestsUnallocated",
    "label": "Resident marital bequests unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.8.0",
    "entity": "estateTax",
    "field": "residentCharitableBequestsFederalTotal",
    "label": "Resident charitable bequests federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.8.1",
    "entity": "estateTax",
    "field": "residentCharitableBequestsNewYork",
    "label": "Resident charitable bequests new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.8.2",
    "entity": "estateTax",
    "field": "residentCharitableBequestsOutsideNewYork",
    "label": "Resident charitable bequests outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.8.3",
    "entity": "estateTax",
    "field": "residentCharitableBequestsUnallocated",
    "label": "Resident charitable bequests unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.9.0",
    "entity": "estateTax",
    "field": "residentDeductionsTotalFederalTotal",
    "label": "Resident deductions total federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.9.1",
    "entity": "estateTax",
    "field": "residentDeductionsTotalNewYork",
    "label": "Resident deductions total new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.9.2",
    "entity": "estateTax",
    "field": "residentDeductionsTotalOutsideNewYork",
    "label": "Resident deductions total outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E1_chart.9.3",
    "entity": "estateTax",
    "field": "residentDeductionsTotalUnallocated",
    "label": "Resident deductions total unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "Line44",
    "entity": "estateTax",
    "field": "residentAllocationOutsidePropertyDollars",
    "label": "Resident allocation outside property dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine44",
    "entity": "estateTax",
    "field": "residentAllocationOutsidePropertyCents",
    "label": "Resident allocation outside property cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line45",
    "entity": "estateTax",
    "field": "residentAllocationFederalEstateDollars",
    "label": "Resident allocation federal estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine45",
    "entity": "estateTax",
    "field": "residentAllocationFederalEstateCents",
    "label": "Resident allocation federal estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line46",
    "entity": "estateTax",
    "field": "residentOutsideAllocationFraction",
    "label": "Resident outside allocation fraction",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line47",
    "entity": "estateTax",
    "field": "residentUnallocatedDeductionsDollars",
    "label": "Resident unallocated deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine47",
    "entity": "estateTax",
    "field": "residentUnallocatedDeductionsCents",
    "label": "Resident unallocated deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line48",
    "entity": "estateTax",
    "field": "residentAllocatedOutsideDeductionsDollars",
    "label": "Resident allocated outside deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine48",
    "entity": "estateTax",
    "field": "residentAllocatedOutsideDeductionsCents",
    "label": "Resident allocated outside deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line49",
    "entity": "estateTax",
    "field": "residentDirectOutsideDeductionsDollars",
    "label": "Resident direct outside deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine49",
    "entity": "estateTax",
    "field": "residentDirectOutsideDeductionsCents",
    "label": "Resident direct outside deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line50",
    "entity": "estateTax",
    "field": "residentDisallowedDeductionTotalDollars",
    "label": "Resident disallowed deduction total dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine50",
    "entity": "estateTax",
    "field": "residentDisallowedDeductionTotalCents",
    "label": "Resident disallowed deduction total cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "E2_chart.0.0",
    "entity": "estateTax",
    "field": "nonresidentFuneralAndAdministrationFederalTotal",
    "label": "Nonresident funeral and administration federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.0.1",
    "entity": "estateTax",
    "field": "nonresidentFuneralAndAdministrationNewYork",
    "label": "Nonresident funeral and administration new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.0.2",
    "entity": "estateTax",
    "field": "nonresidentFuneralAndAdministrationOutsideNewYork",
    "label": "Nonresident funeral and administration outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.0.3",
    "entity": "estateTax",
    "field": "nonresidentFuneralAndAdministrationUnallocated",
    "label": "Nonresident funeral and administration unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.1.0",
    "entity": "estateTax",
    "field": "nonresidentDebtsFederalTotal",
    "label": "Nonresident debts federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.1.1",
    "entity": "estateTax",
    "field": "nonresidentDebtsNewYork",
    "label": "Nonresident debts new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.1.2",
    "entity": "estateTax",
    "field": "nonresidentDebtsOutsideNewYork",
    "label": "Nonresident debts outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.1.3",
    "entity": "estateTax",
    "field": "nonresidentDebtsUnallocated",
    "label": "Nonresident debts unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.2.0",
    "entity": "estateTax",
    "field": "nonresidentMortgagesAndLiensFederalTotal",
    "label": "Nonresident mortgages and liens federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.2.1",
    "entity": "estateTax",
    "field": "nonresidentMortgagesAndLiensNewYork",
    "label": "Nonresident mortgages and liens new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.2.2",
    "entity": "estateTax",
    "field": "nonresidentMortgagesAndLiensOutsideNewYork",
    "label": "Nonresident mortgages and liens outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.2.3",
    "entity": "estateTax",
    "field": "nonresidentMortgagesAndLiensUnallocated",
    "label": "Nonresident mortgages and liens unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.3.0",
    "entity": "estateTax",
    "field": "nonresidentClaimsTotalFederalTotal",
    "label": "Nonresident claims total federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.3.1",
    "entity": "estateTax",
    "field": "nonresidentClaimsTotalNewYork",
    "label": "Nonresident claims total new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.3.2",
    "entity": "estateTax",
    "field": "nonresidentClaimsTotalOutsideNewYork",
    "label": "Nonresident claims total outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.3.3",
    "entity": "estateTax",
    "field": "nonresidentClaimsTotalUnallocated",
    "label": "Nonresident claims total unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.4.0",
    "entity": "estateTax",
    "field": "nonresidentAllowableClaimsFederalTotal",
    "label": "Nonresident allowable claims federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.4.1",
    "entity": "estateTax",
    "field": "nonresidentAllowableClaimsNewYork",
    "label": "Nonresident allowable claims new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.4.2",
    "entity": "estateTax",
    "field": "nonresidentAllowableClaimsOutsideNewYork",
    "label": "Nonresident allowable claims outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.4.3",
    "entity": "estateTax",
    "field": "nonresidentAllowableClaimsUnallocated",
    "label": "Nonresident allowable claims unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.5.0",
    "entity": "estateTax",
    "field": "nonresidentAdministrationLossFederalTotal",
    "label": "Nonresident administration loss federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.5.1",
    "entity": "estateTax",
    "field": "nonresidentAdministrationLossNewYork",
    "label": "Nonresident administration loss new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.5.2",
    "entity": "estateTax",
    "field": "nonresidentAdministrationLossOutsideNewYork",
    "label": "Nonresident administration loss outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.5.3",
    "entity": "estateTax",
    "field": "nonresidentAdministrationLossUnallocated",
    "label": "Nonresident administration loss unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.6.0",
    "entity": "estateTax",
    "field": "nonresidentNonClaimExpenseFederalTotal",
    "label": "Nonresident non claim expense federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.6.1",
    "entity": "estateTax",
    "field": "nonresidentNonClaimExpenseNewYork",
    "label": "Nonresident non claim expense new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.6.2",
    "entity": "estateTax",
    "field": "nonresidentNonClaimExpenseOutsideNewYork",
    "label": "Nonresident non claim expense outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.6.3",
    "entity": "estateTax",
    "field": "nonresidentNonClaimExpenseUnallocated",
    "label": "Nonresident non claim expense unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.7.0",
    "entity": "estateTax",
    "field": "nonresidentMaritalBequestsFederalTotal",
    "label": "Nonresident marital bequests federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.7.1",
    "entity": "estateTax",
    "field": "nonresidentMaritalBequestsNewYork",
    "label": "Nonresident marital bequests new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.7.2",
    "entity": "estateTax",
    "field": "nonresidentMaritalBequestsOutsideNewYork",
    "label": "Nonresident marital bequests outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.7.3",
    "entity": "estateTax",
    "field": "nonresidentMaritalBequestsUnallocated",
    "label": "Nonresident marital bequests unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.8.0",
    "entity": "estateTax",
    "field": "nonresidentCharitableBequestsFederalTotal",
    "label": "Nonresident charitable bequests federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.8.1",
    "entity": "estateTax",
    "field": "nonresidentCharitableBequestsNewYork",
    "label": "Nonresident charitable bequests new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.8.2",
    "entity": "estateTax",
    "field": "nonresidentCharitableBequestsOutsideNewYork",
    "label": "Nonresident charitable bequests outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.8.3",
    "entity": "estateTax",
    "field": "nonresidentCharitableBequestsUnallocated",
    "label": "Nonresident charitable bequests unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.9.0",
    "entity": "estateTax",
    "field": "nonresidentDeductionsTotalFederalTotal",
    "label": "Nonresident deductions total federal total",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.9.1",
    "entity": "estateTax",
    "field": "nonresidentDeductionsTotalNewYork",
    "label": "Nonresident deductions total new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.9.2",
    "entity": "estateTax",
    "field": "nonresidentDeductionsTotalOutsideNewYork",
    "label": "Nonresident deductions total outside new york",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "E2_chart.9.3",
    "entity": "estateTax",
    "field": "nonresidentDeductionsTotalUnallocated",
    "label": "Nonresident deductions total unallocated",
    "location": "Deductible liabilities + additional tax deductions, grouped by category and allocation",
    "selector": null
  },
  {
    "pdfField": "Line61",
    "entity": "estateTax",
    "field": "nonresidentAllocationOutsidePropertyDollars",
    "label": "Nonresident allocation outside property dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine61",
    "entity": "estateTax",
    "field": "nonresidentAllocationOutsidePropertyCents",
    "label": "Nonresident allocation outside property cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line62",
    "entity": "estateTax",
    "field": "nonresidentAllocationFederalEstateDollars",
    "label": "Nonresident allocation federal estate dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine62",
    "entity": "estateTax",
    "field": "nonresidentAllocationFederalEstateCents",
    "label": "Nonresident allocation federal estate cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line63",
    "entity": "estateTax",
    "field": "nonresidentOutsideAllocationFraction",
    "label": "Nonresident outside allocation fraction",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine64",
    "entity": "estateTax",
    "field": "nonresidentUnallocatedDeductionsCents",
    "label": "Nonresident unallocated deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line64",
    "entity": "estateTax",
    "field": "nonresidentUnallocatedDeductionsDollars",
    "label": "Nonresident unallocated deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line65",
    "entity": "estateTax",
    "field": "nonresidentAllocatedOutsideDeductionsDollars",
    "label": "Nonresident allocated outside deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine65",
    "entity": "estateTax",
    "field": "nonresidentAllocatedOutsideDeductionsCents",
    "label": "Nonresident allocated outside deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line66",
    "entity": "estateTax",
    "field": "nonresidentDirectOutsideDeductionsDollars",
    "label": "Nonresident direct outside deductions dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine66",
    "entity": "estateTax",
    "field": "nonresidentDirectOutsideDeductionsCents",
    "label": "Nonresident direct outside deductions cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line67",
    "entity": "estateTax",
    "field": "nonresidentStateDeathTaxDeductionDollars",
    "label": "Nonresident state death tax deduction dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine67",
    "entity": "estateTax",
    "field": "nonresidentStateDeathTaxDeductionCents",
    "label": "Nonresident state death tax deduction cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "Line68",
    "entity": "estateTax",
    "field": "nonresidentDisallowedDeductionTotalDollars",
    "label": "Nonresident disallowed deduction total dollars",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "CentsLine68",
    "entity": "estateTax",
    "field": "nonresidentDisallowedDeductionTotalCents",
    "label": "Nonresident disallowed deduction total cents",
    "location": "Computed from estate-tax filing, property and deductible liabilities",
    "selector": null
  },
  {
    "pdfField": "F_Description_litigation",
    "entity": "estateTaxFiling",
    "field": "litigationDescription",
    "label": "Cause of action or litigation involving the decedent, including actual or estimated values",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "Attorney",
    "entity": "taxRepresentative",
    "field": "isAttorney",
    "label": "Qualification: attorney",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "PA",
    "entity": "taxRepresentative",
    "field": "isCertifiedPublicAccountant",
    "label": "Qualification: certified public accountant",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Agent",
    "entity": "taxRepresentative",
    "field": "isEnrolledAgent",
    "label": "Qualification: enrolled agent",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "NYSEdu",
    "entity": "taxRepresentative",
    "field": "isNewYorkPublicAccountant",
    "label": "Qualification: public accountant enrolled with NYS Education Department",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "Datesign",
    "entity": "estateTaxFiling",
    "field": "representativeRecordedSigningDate",
    "label": "Recorded representative authorization date (does not sign)",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "AttorneyEmail",
    "entity": "taxRepresentative",
    "field": "email",
    "label": "Email",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Authorized tax representative",
    "selector": null
  },
  {
    "pdfField": "DateEX",
    "entity": "estateTaxFiling",
    "field": "executorRecordedSigningDate",
    "label": "Recorded executor signing date (does not sign the return)",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "DateEXCO",
    "entity": "estateTaxFiling",
    "field": "coexecutorRecordedSigningDate",
    "label": "Recorded co-executor signing date (does not sign the return)",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "PrintPreparer",
    "entity": "taxPreparer",
    "field": "fullName",
    "label": "Full name",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  },
  {
    "pdfField": "PrepSSN",
    "entity": "taxPreparer",
    "field": "taxIdentifier",
    "label": "PTIN or SSN",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  },
  {
    "pdfField": "PrepNYTPRIN",
    "entity": "taxPreparer",
    "field": "nyTaxPreparerRegistrationId",
    "label": "NY tax preparer registration number (NYTPRIN)",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  },
  {
    "pdfField": "AddPrep",
    "entity": "taxPreparer",
    "field": "addresses[0].addressLine1",
    "label": "Street address",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  },
  {
    "pdfField": "PrepCity",
    "entity": "taxPreparer",
    "field": "addresses[0].city",
    "label": "City",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  },
  {
    "pdfField": "PrepState",
    "entity": "taxPreparer",
    "field": "addresses[0].state",
    "label": "State",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  },
  {
    "pdfField": "PrepZIP",
    "entity": "taxPreparer",
    "field": "addresses[0].zipCode",
    "label": "ZIP code",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  },
  {
    "pdfField": "DatePrep",
    "entity": "estateTaxFiling",
    "field": "preparerRecordedSigningDate",
    "label": "Recorded preparer signing date (does not sign the return)",
    "location": "Family Jewels → Estate tax filing",
    "selector": null
  },
  {
    "pdfField": "PrepEmail",
    "entity": "taxPreparer",
    "field": "email",
    "label": "Email",
    "location": "Participants → professional details; Estate details → Estate tax professionals → Tax return preparer",
    "selector": null
  }
];
